// extracted by mini-css-extract-plugin
export default {"footer":"ShowcaseFooter_footer__hDm7E"};